export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";